<template>
  <Wrapper :width="300" class="px-gd-3 py-gd-2">
    <div class="detail" v-if="fileHighlight">
      <FileWrapper id="detail-img-preview" class="text-center select-img">
        <!-- <FileThumbnail
          v-if="isDoc && typeFile == 'pdf'"
          :imgsrc="require(`@/assets/images/icon/filemanager/thumb-pdf.jpg`)"
          class="select-img"
        />
        <FileThumbnail
          v-else-if="isDoc && typeFile == 'doc'"
          :imgsrc="require(`@/assets/images/icon/filemanager/thumb-doc.jpg`)"
          class="select-img"
        />
        <FileThumbnail
          v-else-if="isDoc && typeFile == 'ppt'"
          :imgsrc="require(`@/assets/images/icon/filemanager/thumb-ppt.jpg`)"
          class="select-img"
        />
        <FileThumbnail
          v-else-if="isDoc && typeFile == 'xls'"
          :imgsrc="require(`@/assets/images/icon/filemanager/thumb-xls.jpg`)"
          class="select-img"
        />
        <FileThumbnail
          v-else-if="isDoc && typeFile == 'txt'"
          :imgsrc="require(`@/assets/images/icon/filemanager/thumb-txt.jpg`)"
          class="select-img"
        /> -->

        <FileThumbnail v-if="isDoc">
            <div class="icon-name">
              <span class="pdf" v-show="isDoc && typeFile == 'pdf'">
                <i class="fas fa-file-pdf"></i>
              </span>
              <span class="word" v-show="isDoc && typeFile == 'doc'">
                <i class="fas fa-file-word"></i>
              </span>
              <span class="powerpoint" v-show="isDoc && typeFile == 'ppt'">
                <i class="fas fa-file-powerpoint"></i>
              </span>
              <span class="excel" v-show="isDoc && typeFile == 'xls'">
                <i class="fas fa-file-excel"></i>
              </span>
              <span class="txt" v-show="isDoc && typeFile == 'txt'">
                <i class="fas fa-file-alt"></i>
              </span>
            </div>
          </FileThumbnail>
        <FileThumbnail
          v-else
          :imgsrc="fileHighlight.url.replace('{{size}}', 'r_400x400')"
          class="select-img"
        />
      </FileWrapper>

      <div class="my-gd-1">
        <div class="fs-sa-14 text-break">
          <b class="fs-dbb-16" style="min-width: fit-content">{{$t('engine.filemanager.filelist.fileName', languageEngine)}} :</b>
          {{ fileHighlight.name }}
        </div>
        <div class="fs-sa-14 text-break mt-gd-1">
          <b class="fs-dbb-16">{{$t('engine.filemanager.filelist.fileSize', languageEngine)}} :</b>
          {{ fileHighlight.size }}
        </div>
        <div class="fs-sa-14 text-break mt-gd-1">
          <b class="fs-dbb-16">{{$t('engine.filemanager.filelist.dateUpload', languageEngine)}} :</b>
          {{ fileHighlight.uploadedAt }}
        </div>
      </div>

      <hr class="my-0" style="margin-left: -24px; margin-right: -24px" />

      <div class="mt-gd-1" v-if="!isDoc">
        <div
          :class="{
            errors: !$v.fileHighlight.alt.alpha,
          }"
        >
          <label class="fs-sa-14" for="img-alt-right">
            {{$t('engine.filemanager.imgAlt', languageEngine)}}
            <span v-if="savingAlt" class="text-success float-end">
              <i class="far fa-check"></i>{{$t('engine.filemanager.imgAltSaved', languageEngine)}} 
            </span>
          </label>
          <b-form-input
            style="height: 24px"
            id="img-alt-right"
            v-model="fileHighlight.alt"
            :class="{
              errors: !$v.fileHighlight.alt.alpha,
            }"
            @blur="update()"
            @keyup.enter.native="update()"
          ></b-form-input>
          <small v-if="!$v.fileHighlight.alt.alpha">
            {{$t('engine.filemanager.imgAlt.invalid.nameFormat', languageEngine)}}
          </small>
        </div>

        <div class="fs-sa-14 mt-gd-1">
          <b-form-checkbox
            id="checkbox-title"
            v-model="fileHighlight.isSameAlt"
            :value="true"
            :unchecked-value="false"
            @change="updateIsSameAlt()"
          >
            {{$t('engine.filemanager.imgAltChkbox', languageEngine)}}
          </b-form-checkbox>
        </div>

        <template v-if="!fileHighlight.isSameAlt">
          <div
            class="mt-gd-1"
            :class="{
              errors: !$v.fileHighlight.title.alpha,
            }"
          >
            <label class="fs-sa-14" for="img-title-right">
              {{$t('engine.filemanager.imgTitle', languageEngine)}}
              <span v-if="savingTitle" class="text-success float-end">
                <i class="far fa-check"></i> {{$t('engine.filemanager.imgAltSaved', languageEngine)}}
              </span>
            </label>
            <b-form-input
              style="height: 24px"
              id="img-title-right"
              v-model="fileHighlight.title"
              :class="{
                errors: !$v.fileHighlight.title.alpha,
              }"
              @blur="updateTitle()"
              @keyup.enter.native="updateTitle()"
            ></b-form-input>
            <small v-if="!$v.fileHighlight.title.alpha">
              {{$t('engine.filemanager.imgAlt.invalid.nameFormat', languageEngine)}}
            </small>
          </div>
        </template>
      </div>
      <div class="mt-gd-2" >
        <label class="fs-sa-14" for="text-to-copy"> {{$t('engine.filemanager.fileURL', languageEngine)}} </label>
        <b-input-group>
          <template #append>
            <b-input-group-text
              style="height: 24px; cursor: pointer"
              @click="copyUrlFile(fileHighlight.url)"
            >
              <span><i class="far fa-copy"></i></span>
            </b-input-group-text>
          </template>
          <b-form-input
            style="height: 24px"
            id="text-to-copy"
            name="text-to-copy"
            :value="
              decodeURIComponent(fileHighlight.url).replace(
                '{{size}}',
                'r_400x400'
              )
            "
            readonly
          ></b-form-input>
        </b-input-group>
      </div>
    </div>
    <template v-else>
      <div class="no-item fs-sa-14 text-center">{{$t('engine.filemanager.noItem', languageEngine)}}</div>
    </template>
  </Wrapper>
</template>

<script>
import { Wrapper, FileWrapper, FileThumbnail } from "./Filemanager.styled";
import { helpers } from "vuelidate/lib/validators";
import fileService from "@services/fileService.js";
import { mapGetters } from "vuex";
const alpha = helpers.regex("alpha", /^[^`~!@#$%^&*()+={}|:;“’<>?๐'฿]*$/);

export default {
  data() {
    return {
      savingAlt: false,
      savingTitle: false,
      localAlt: '',
      localTitle: '',
    };
  },
  components: {
    Wrapper,
    FileWrapper,
    FileThumbnail,
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
    }),
    isDoc() {
      const file = this.fileHighlight;
      const img = "image/jpg, image/jpeg, image/png, image/gif, image/webp";
      if (img.search(file.extension) != -1) {
        return false;
      } else {
        return true;
      }
    },
    typeFile() {
      return this.documentIcon(this.fileHighlight.extension);
    },
    fileHighlightId() {
      return this.fileHighlight && this.fileHighlight.id
    }
  },
  methods: {
    copyUrlFile() {
      var copyText = document.querySelector("#text-to-copy");
      copyText.select();
      document.execCommand("copy");
    },
    documentIcon(type) {
      let type_file = ``;
      const doc = "pdf, ppt, pptx, doc ,docx, xls,xlsx,txt";
      if (doc.toLowerCase().search(type.toLowerCase()) != -1) {
        switch (type.toLowerCase()) {
          case "pdf":
            type_file = "pdf";
            break;
          case "ppt":
          case "pptx":
            type_file = "ppt";
            break;
          case "doc":
          case "docx":
            type_file = "doc";
            break;
          case "xls":
          case "xlsx":
            type_file = "xls";
            break;
          default:
            type_file = "txt";
        }
      }
      return type_file;
    },
    update() {
      if (this.localAlt == this.fileHighlight.alt) return

      this.$v.fileHighlight.$touch();
      if (this.$v.fileHighlight.$invalid) return;

      this.savingAlt = true;
      this.localAlt =  this.fileHighlight.alt;

      const fileID = this.fileHighlight.id;
      fileService.updateFile(fileID, this.fileHighlight).then(() => {
        setTimeout(() => {
          this.savingAlt = false;
        }, 2500);
      });
    },
    updateIsSameAlt() {
      const fileID = this.fileHighlight.id;
      fileService.updateFile(fileID, this.fileHighlight);
    },
    updateTitle() {
      if (this.localTitle == this.fileHighlight.title) return
      
      this.$v.fileHighlight.$touch();
      if (this.$v.fileHighlight.$invalid) return;

      this.savingTitle = true;
      this.localTitle =  this.fileHighlight.title;

      const fileID = this.fileHighlight.id;
      fileService.updateFile(fileID, this.fileHighlight).then(() => {
        setTimeout(() => {
          this.savingTitle = false;
        }, 2500);
      });
    },
  },
  props: {
    fileHighlight: {},
  },
  validations: {
    fileHighlight: {
      title: {
        alpha,
      },
      alt: {
        alpha,
      },
    },
  },
  watch: {
    fileHighlightId: {
      handler() {
        if (this.fileHighlightId == null) {
          this.localTitle =  '';
          this.localAlt = '';
        } else {
          this.localTitle =  this.fileHighlight.title;
          this.localAlt =  this.fileHighlight.alt;
        }
       
      }
    }
  }
};
</script>

<style scoped>
.pdf svg{
    color : #E13022;
}
.word svg{
    color : #3BA9FF;
}
.powerpoint svg{
    color : #F89605;
}
.excel svg{
    color : #429600;
}
.txt svg{
    color : #373E44;
}
</style>
